import { render, staticRenderFns } from "./guideUse.vue?vue&type=template&id=0700b956&"
import script from "./guideUse.vue?vue&type=script&lang=js&"
export * from "./guideUse.vue?vue&type=script&lang=js&"
import style0 from "./guideUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports